/* ============================================================
   custom-testimonial-carousel.js
   Avance automatico y puntos del carrusel de resenas.

   El desplazamiento en si lo hace el CSS (scroll-snap), asi que
   si este script no llega a cargar el carrusel sigue siendo
   usable: se arrastra a mano. Aqui solo se anade el avance
   solo, la sincronizacion de los puntos y las pausas.
   ============================================================ */

class TestimonialCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-tc-track]');
    this.slides = Array.from(this.querySelectorAll('[data-tc-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-tc-dot]'));

    if (!this.track || this.slides.length < 2) return;

    this.index = 0;
    this.timer = null;
    this.interval = Number(this.dataset.interval) || 5000;
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        this.goTo(i);
        this.restart();
      });
    });

    let frame;
    this.track.addEventListener(
      'scroll',
      () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => this.syncFromScroll());
      },
      { passive: true }
    );

    // Se para mientras se mira, se toca o la pestana esta en segundo plano
    this.addEventListener('pointerenter', () => this.stop());
    this.addEventListener('pointerleave', () => this.start());
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', () => this.start());

    this.onVisibility = () => (document.hidden ? this.stop() : this.start());
    document.addEventListener('visibilitychange', this.onVisibility);

    this.setActive(0);
    this.start();
  }

  disconnectedCallback() {
    this.stop();
    document.removeEventListener('visibilitychange', this.onVisibility);
  }

  syncFromScroll() {
    const width = this.track.clientWidth;
    if (!width) return;
    const i = Math.round(this.track.scrollLeft / width);
    if (i !== this.index) this.setActive(i);
  }

  setActive(i) {
    this.index = Math.max(0, Math.min(i, this.slides.length - 1));

    this.dots.forEach((dot, n) => {
      const on = n === this.index;
      dot.classList.toggle('is-active', on);
      if (on) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  }

  goTo(i) {
    this.setActive(i);
    this.track.scrollTo({
      left: this.track.clientWidth * this.index,
      behavior: this.reduced.matches ? 'auto' : 'smooth',
    });
  }

  next() {
    this.goTo((this.index + 1) % this.slides.length);
  }

  start() {
    if (this.timer || this.reduced.matches) return;
    this.timer = setInterval(() => this.next(), this.interval);
  }

  stop() {
    clearInterval(this.timer);
    this.timer = null;
  }

  restart() {
    this.stop();
    this.start();
  }
}

if (!customElements.get('testimonial-carousel')) {
  customElements.define('testimonial-carousel', TestimonialCarousel);
}
